import { Component } from '@angular/core';
import { UserContext } from '@app/shared/services/context/user.context.service';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.sass'],
})
export class UserProfileComponent {
  constructor(public readonly _authSvc: AuthService, public readonly _usrCtxSvc: UserContext) {}
}
